import { ProgramNames } from '../../../models/programs/Programs'
import { PROVIDER_TYPES } from '../../../models/providers/Providers'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { LTSessionTypes } from '../../sessions/constants'
import { ConsentText, ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const CLINICAL_LEAVE_EVALUATION_PROGRAM = {
  programName: ProgramNames.ClinicalLeaveEvaluation,
  blendedCareProgramId: '6f146c5b-ac3b-42e5-b2a2-aacb3035e6d8',
  customerPropertyId: ProgramCustomerPropertyId.clinicalLeaveEvaluation,

  displayLabels: {
    default: ProgramDisplayLabels.clinicalLeaveEvaluation,
    short: 'CLE',
    clientProfile: 'Short Term Disability Eval',
    sessionSummary: 'short term disability evaluation',
  },

  associatedProviderTypes: [PROVIDER_TYPES.LYRACLINICALLEAVEEVALUATOR.lyraType],
  associatedProviderModalities: ['clinicalLeaveEvaluation'],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  sessionTypeConfig: {
    sessionType: LTSessionTypes.INITIAL_CLE_SESSION,
    followupSessionType: LTSessionTypes.FOLLOWUP_CLE_SESSION,
    rateStrategy: 'fixed',
  },

  directBookingParams: {
    clientele: PROGRAM_TAXONOMY.clientele.individual,
    treatment: PROGRAM_TAXONOMY.treatment.assessment,
    partner: PROGRAM_TAXONOMY.partner.blendedCare,
    offering: PROGRAM_TAXONOMY.offering.clinicalLeave,
  },

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.CLINICAL_LEAVE_EVALUATION],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.assessment,
        partner: PROGRAM_TAXONOMY.partner.blendedCare,
        offering: PROGRAM_TAXONOMY.offering.clinicalLeave,
      },
    ],
    isFullTreatmentOption: false,
  },

  consents: [
    {
      consentText: ConsentText.therapyConsent,
      consentUrl: 'https://www.lyrahealth.com/lt-agreement',
      showConsentIf: () => true,
    },
  ],

  noteContentMetadataName: {
    INITIAL_NOTE: 'cleInitialNote',
    SESSION_NOTE: 'cleSessionNote',
    GENERAL_NOTE: 'cleGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
  },
} satisfies ProgramConfig
